import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import MessageOutlinedIcon from 'components/material-symbol/icons/Message'
import NewConversationDialog from './new-conversation-dialog'

const useStyles = makeStyles(theme => ({
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
}))

const EmptyChannel = () => {
  const classes = useStyles()

  return (
    <Box className={classes.emptyStateContent}>
      <SectionEmptyState
        Icon={MessageOutlinedIcon}
        title="No conversations yet"
        caption="Messages will appear here once you start a conversation"
        bordered={false}
        action={
          <NewConversationDialog
            trigger={<TonalButton>Start Messaging</TonalButton>}
          />
        }
      />
    </Box>
  )
}

export default EmptyChannel
